require("avatars/owl_photos_display.scss");

import { Prompt } from "react-router-dom";
import { connect } from "react-redux";

var PhotoBooth = require("components/games/PhotoBooth")
var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var CoinDisplay = require("components/utility/CoinDisplay");

var html2canvas = require("html2canvas");

var PhotoBackgrounds = require("lib/games/PhotoBackgrounds");
var PhotoCaptions = require("lib/games/PhotoCaptions");
var Tiers = require("lib/games/Tiers");
var CurrentUser = require("lib/account/CurrentUser");

var OwlShopActions = require("lib/actions/OwlShopActions");
var OwlShopSelectors = require("lib/selectors/OwlShopSelectors");
var ClassPageRouting = require("lib/routing/ClassPageRouting");

@connect(
	(state, props) => ({
		currentUser: CurrentUser.get(),
		loading: OwlShopSelectors.isLoadingPhotographs({ state, key: "create" })
	}),
	(dispatch, props) => ({
		createPhotograph: (image) => {
			return dispatch(OwlShopActions.createPhotograph({
				photograph: { image }
			})).then(() => {
				CurrentUser.fetchCurrentUserData();
				return Promise.resolve();
			})
		}
	}),
)

class OwlPhotosDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			backgroundIndex: Math.floor(Math.random() * this.backgroundsImages().length),
			captionIndex: Math.floor(Math.random() * this.photoCaptions().length),
			avatarSize: 140,
			avatarPos: {top: 0, left: 0},
			disabledButton: true
		}
	}

	backgroundsImages() {
		return _.pluck(PhotoBackgrounds.IMAGES, "path");
	}

	photoCaptions() {
		return _.pluck(PhotoCaptions.CAPTIONS, "text");
	}

	selectBackground = (background) => {
		this.setState({ selectedBackground: background });
	}
	renderMain = () => {
		var background = this.backgroundsImages()[this.state.backgroundIndex]
		var caption = this.photoCaptions()[this.state.captionIndex]

		var mainDisplay = (
			<div><PhotoBooth width={ 350 } 
					avatarPos={ this.state.avatarPos } 
					avatarSize={ this.state.avatarSize } 
					background={ background } caption={caption}
					placeOwlCenter={this.placeOwlCenter} /></div>
		)
		return (
			<div className="photos" style={{ background: this.state.selectedBackground ? "inherit" : "" }}>
				{ mainDisplay }
			</div>	
		)
	}

	shiftCarousel(indexKey, dir, list_len) {
		var index = this.state[indexKey]
		if (dir == "random") {
			index = Math.floor(Math.random() * list_len);
		} else {
			index += dir			
		}
		if (index >= list_len) {
			index = 0
		} else if (index < 0) {
			index = list_len - 1
		}
		var newState = {}
		newState[indexKey] = index
		this.setState(newState)
	}

	renderCarousel(list, indexKey, itemN) {
		var index = this.state[indexKey]
		
		if (itemN > 1) {
			var indexes = [index - 1, index, index + 1]	
		} else {
			var indexes = [index]
		}

		const carouselItems = _.map(indexes, (i) => {
			if (i < 0) {
				i = list.length - 1
			} else if (i >= list.length) {
				i = 0
			}
			var imagePath = list[i]
			if (indexKey == "backgroundIndex") {
				var item = ( <img style={{width: "100%", "height": "100%"}} src={ imagePath} /> )
			} else if (indexKey == "captionIndex") {
				var item = imagePath
			} 
			return (
				<div key={i} className={"carouselItem text-center " + (i == index ? "bg selected": "bg")} >
					{ item }
				</div>
			)
		});

		return (
			<div className="carousel">
				{ carouselItems }
				<div className="carouselControl">
					<button className="btn btn-link arrow"
						onClick={ this.shiftCarousel.bind(this, indexKey, -1, list.length) }>
						<Glyphicon icon="arrow-left" />
					</button>
					<button className="btn btn-link arrow"
						onClick={ this.shiftCarousel.bind(this, indexKey, "random", list.length) }>
						<Glyphicon icon="random" />
					</button>
					<button className="btn btn-link arrow"
						onClick={ this.shiftCarousel.bind(this, indexKey, 1, list.length) }>
						<Glyphicon icon="arrow-right" />
					</button>
				</div>
			</div>
		)
	}
	
	renderControls = () => {
		return (
			<div className="controls">
				{ this.renderPhotoControls() }
			</div>
		)
	}
	isSelected = (background) =>  {
		return this.state.selectedBackground == background;
	}
	renderPhotoControls = () => {
		var isSelected;
		
		var backgrounds = (
			<div className="controlSection backgrounds">
				<p className="controlHeader">Backgrounds</p>
				{ this.renderCarousel(this.backgroundsImages(), "backgroundIndex", 3) }
			</div>
		)
		var caption = (
			<div className="controlSection caption">
				<p className="controlHeader">Caption</p>
				{ this.renderCarousel(this.photoCaptions(), "captionIndex", 1) }
			</div>
		)
		var owlControl = (
			<div className="controlSection xyControl owlControl">
				<p className="controlHeader">Position</p>
				<div className="positionControl">
					<button className="btn btn-link arrow left" onClick={this.toggleAvatarPos.bind(this, -1, 0)}>
						<Glyphicon icon="arrow-left" />
					</button>
					<button className="btn btn-link arrow up" onClick={this.toggleAvatarPos.bind(this, 0, -1)}>
						<Glyphicon icon="arrow-up" />
					</button>
					<button className="btn btn-link arrow down" onClick={this.toggleAvatarPos.bind(this, 0, 1)}>
						<Glyphicon icon="arrow-down" />
					</button>
					<button className="btn btn-link arrow right" onClick={this.toggleAvatarPos.bind(this, 1, 0)}>
						<Glyphicon icon="arrow-right" />
					</button>
				</div>
			</div>
		)
		var owlSize = (
			<div className="controlSection owlControl">
				<p className="controlHeader">Size</p>
				<div className="positionControl">
					<button className="btn btn-link arrow">
						<Glyphicon icon="minus-sign" onClick={this.toggleAvatarSize.bind(this, -1)}/>
					</button>
					<button className="btn btn-link arrow">
						<Glyphicon icon="plus-sign" onClick={this.toggleAvatarSize.bind(this, 1)}/>
					</button>
				</div>
			</div>
		)
				
		var cost = Tiers.getQunitXValue("take_photo", this.props.currentUser.tier);
		
		if (this.props.currentUser.coins < cost) {
			var userCostMessage = ". You only have " + this.props.currentUser.coins + " coins!"
		}
		
		var priceInfo = (
			<p>
				Taking a photo costs <CoinDisplay coins={ cost } height={ 20 } />{ userCostMessage }
			</p>
		)
		var addPhotoControls = (
			<div className="addPhotoControls">
				{ backgrounds }
				{ caption }
				{ owlControl }
				{ owlSize }
				<div className="text-center">
					{ priceInfo }
					<LoadingButton text="Snap My Photo!" className="btn buttonPrimary"
						disabled={ (this.props.currentUser.coins < cost) || this.state.disabledButton }
						onClick={ this.takePhoto } loading={ this.props.loading } />
				</div>
			</div>
		)
		return (
			<div>
				{ addPhotoControls }
			</div>
		)
	}

	toggleAvatarPos(w, h) {
		const owlSize = this.getRefSize($("#boothAvatar"))
		const imageSize = this.getRefSize($("#boothImage"))

		var step = imageSize.w * 0.05
		
		w = w * step
		h = h * step 
		
		var pos = this.state.avatarPos
		var newLeft = pos.left + w
		var newTop = pos.top + h

		if (newLeft < 3) {
			newLeft = 3
		} else if (newLeft + owlSize.w > imageSize.w - 3) {
			newLeft = imageSize.w - 3 - owlSize.w
		}

		if (newTop < 3) {
			newTop = 3
		} else if (newTop + owlSize.h > imageSize.h - 3) {
			newTop = imageSize.h - 3 - owlSize.h
		}
		const avatarPos = {top: newTop, left: newLeft}
		
		this.setState({ avatarPos })
	}

	toggleAvatarSize(size) {
		const MIN_AVATAR_SIZE = 75;
		const MAX_AVATAR_SIZE = 200;

		const imageSize = this.getRefSize($("#boothAvatar"));

		var step = (imageSize.w * 0.1)
		size = step * size
		var newSize = this.state.avatarSize + size;
		
		if (newSize < MIN_AVATAR_SIZE) {
			newSize = MIN_AVATAR_SIZE
		}
		if (newSize > MAX_AVATAR_SIZE) {
			newSize = MAX_AVATAR_SIZE
		}
				
		this.setState({avatarSize: newSize}, this.toggleAvatarPos.bind( this,0,0))
	}
	takePhoto() {
		// Needs to be at top of page and hide the scrollback, for some stupid reason
		window.scrollTo(0, 0)
		document.body.style.overflow = 'hidden';
		
		this.setState({ disabledButton: true })

		var element = $("#polaroid .inner")[0]
		html2canvas(element, { width: $(element).width() }).then((canvas) => {
			var originalDataURL = canvas.toDataURL();
			
			var imageFile = window.imageCompression.getFilefromDataUrl(originalDataURL).then((imageFile) => {
				const options = { 
				  maxSizeMB: 0.7
				}
 
				window.imageCompression(imageFile, options).then((compressedBlob) => {
					window.imageCompression.getDataUrlFromFile(compressedBlob).then((compressedDataURL) => {
						
						this.props.createPhotograph(compressedDataURL).then(() => {
							$wr.redirect(ClassPageRouting.getPath({
								activeView: ClassPageRouting.VIEWS.PHOTO_VIEW
							}));
						})
					})
				})

			})
			
	    // document.body.appendChild(canvas);
			
			document.body.style.overflow = 'visible';
		});
	}
	getRefSize(element) {
		const width = element.width();
		const height = element.height();
		return { w: width, h: height };
	}
	placeOwlCenter() {
		const owlSize = this.getRefSize($("#boothAvatar"));
		const imageSize = this.getRefSize($("#boothImage"));

		const owlWMidePoint = owlSize.w / 2.0
		const owlHMidePoint = owlSize.h / 2.0
		const imageWMidePoint = imageSize.w / 2.0
		const imageHMidePoint = imageSize.h / 2.0

		this.setState({avatarPos: {top: imageHMidePoint - owlHMidePoint, left: imageWMidePoint - owlHMidePoint}})
	}
	renderCurtain() {
		var openingTime = $wr.getShopOpeningTime(this.props.currentUser);
		var src = require("tiers/lock.png");
		var patchImg = <img src={src} className="lockImg" />;
		if (openingTime != "Never") {
			var openingDetails = "It will open today at " + openingTime;
		}
		return (
			<div className="curtain">
				<div>{patchImg}</div>
				<p>
					Your teacher has closed the Owlstagram. <br />
					{openingDetails}
				</p>
			</div>
		);
	}
	render() {
		var openClass = ""
   		if (this.props.currentUser && !$wr.shouldShopOpen(this.props.currentUser)) {
			openClass = "closedShop";
			var curtain = this.renderCurtain();
		}
		else {
			var curtain = <div></div>
		}
		var main = this.renderMain();
		var controls = this.renderControls();
		return (
			<div className="owlPhotosContainer">
				{curtain}
				<div className={openClass}>
					{ main }
					{ controls }
				</div>
			</div>
			
		);
	}
	componentDidMount() {
		$wr.loadScript("/dependencies/browserImageCompression.js", "imageCompression", () => {
			this.setState({ disabledButton: false });
		})
	}
}

OwlPhotosDisplay.WrappedComponent.propTypes = PageStrictPropTypes({
	currentUser: PropTypes.object,
	loading: PropTypes.bool,
	createPhotograph: PropTypes.func
});

module.exports = OwlPhotosDisplay;


// WEBPACK FOOTER //
// ./modules/components/avatars/OwlPhotosDisplay.js